import React from 'react';
import PropTypes from 'prop-types';

const ColumnHorizontal01Icon = ({color = 'currentColor', ...props}) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.5002 14.8333C16.5002 15.7538 15.7643 16.5 14.8564 16.5L3.14408 16.5C2.23621 16.5 1.50024 15.7538 1.50024 14.8333L1.50024 12.3333C1.50024 11.4129 2.23621 10.6667 3.14408 10.6667L14.8564 10.6667C15.7643 10.6667 16.5002 11.4129 16.5002 12.3333V14.8333Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.5002 3.16667C16.5002 2.24619 15.7643 1.5 14.8564 1.5L3.14408 1.5C2.23621 1.5 1.50024 2.24619 1.50024 3.16667L1.50024 5.66667C1.50024 6.58714 2.23621 7.33333 3.14408 7.33333H14.8564C15.7643 7.33333 16.5002 6.58714 16.5002 5.66667V3.16667Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

ColumnHorizontal01Icon.propTypes = {
  color: PropTypes.string,
};

export default ColumnHorizontal01Icon;
